import React from "react";

export default function UseIsMobile() {

  const [width, setWidth] = React.useState((typeof window !== "undefined") ?
    window?.innerWidth : ''
  );

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const handleWindowResize = () => setWidth(window?.innerWidth);
      window.addEventListener("resize", handleWindowResize);
      return () => window?.removeEventListener("resize", handleWindowResize);
    }
  }, []);

  // Return the width so we can use it in our components
  return { width };
}